import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/sass/overrides.sass';

Vue.use(Vuetify);

const theme = {
  primary: '#24272A',
  secondary: '#F88D2B',
  accent: '#F88D2B',
  info: '#ffdd59',
  darkgray: '#343444',
  teal: '#40afed',
};

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
  options: {
    customProperties: true,
  },
});
